/** Flag de temperaturas disponíveis na aplicação */
export interface Temperatura {
    id: number;
    nome: string;
    imageSrc: string;
}

export const temperaturaQuente: Temperatura = {
    id: 1,
    nome: 'Quente',
    imageSrc: './assets/img/temperatura/temperatura-quente.png'
};

export const temperaturaMorno: Temperatura = {
    id: 2,
    nome: 'Morno',
    imageSrc: './assets/img/temperatura/temperatura-morno.png'
};

export const temperaturaFrio: Temperatura = {
    id: 3,
    nome: 'Frio',
    imageSrc: './assets/img/temperatura/temperatura-frio.png'
};

export const temperaturas: Temperatura[] = [
    temperaturaQuente,
    temperaturaMorno,
    temperaturaFrio
];

/** Verifica se a temperatura é Quente */
export function isTemperaturaQuente(temperatura: number): boolean {
    if (!temperatura) {
        return false;
    }
    return temperatura === temperaturaQuente.id;
}

/** Verifica se a temperatura é Morno */
export function isTemperaturaMorno(temperatura: number): boolean {
    if (!temperatura) {
        return false;
    }
    return temperatura === temperaturaMorno.id;
}

/** Verifica se a temperatura é Frio */
export function isTemperaturaFrio(temperatura: number): boolean {
    if (!temperatura) {
        return false;
    }
    return temperatura === temperaturaFrio.id;
}
